/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tourh_HInputs */

const en_wc_tourh_h = /** @type {(inputs: Wc_Tourh_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inside the WordCraft app`)
};

/**
* | output |
* | --- |
* | "Inside the WordCraft app" |
*
* @param {Wc_Tourh_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tourh_h = /** @type {((inputs?: Wc_Tourh_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tourh_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tourh_h(inputs)
});
export { wc_tourh_h as "wc.tourh.h" }